import { EContractType, } from "@rentiohq/shared/dist/types/contract.types";
import { ts } from "../services";
export var getDisplayName = function (contract) {
    return [EContractType.Basic, null].includes(contract.contractType)
        ? ts.contractType(EContractType.Basic)
        : ts.contractType(contract.contractType ? contract.contractType : "unknown");
};
